import { Task, ITask } from './task';

export class Tasks {
	public static parse(data: ITasks): Tasks {
		const tasks: Tasks = new Tasks();
		if ((data.value !== undefined) && (data.value.length > 0)) {
			for (const value of data.value) {
				const task: Task = Task.parse(value);
				if (task) {
					tasks.value.push(task);
				}
			}
		}
		return tasks;
	}
	public value: Task[] = [];

	public get(id: string): Task | null {
		for (const task of this.value) {
			if (task.id === id) {
				return task;
			}
		}
		return null;
	}

	public getMyTask(userId: string): Task | null {
		for (const task of this.value) {
			if (task.isAssignment(userId)) {
				return task;
			}
		}
		return null;
	}

	public getMyTasks(userId: string): Tasks {
		const tasks: Tasks = new Tasks();
		for (const task of this.value) {
			if (task.isAssignment(userId)) {
				tasks.value.push(task);
			}
		}
		return tasks;
	}

	public getByTitle(title: string): Task | null {
		for (const task of this.value) {
			if (task.title === title) {
				return task;
			}
		}
		return null;
	}

	public getPlanTasks(planId: string): Task[] {
		const tasks: Task[] = [];
		for (const task of this.value) {
			if (task.planId === planId) {
				tasks.push(task);
			}
		}
		return tasks;
	}

	public getBucketTasks(planId: string, bucketId: string): Tasks {
		const tasks: Tasks = new Tasks();
		for (const task of this.value) {
			if ((task.planId === planId) && (task.bucketId === bucketId)) {
				tasks.value.push(task);
			}
		}
		return tasks;
	}

	public getTasksByTitle(title: string): Tasks {
		const tasks = new Tasks();
		for (const task of this.value) {
			if (task.title === title) {
				tasks.value.push(task);
			}
		}
		return tasks;
	}

	public getMyTaskByTitle(userId: string, title: string): Task | null {
		const tasks: Tasks = new Tasks();
		for (const task of this.value) {
			if (task.isAssignment(userId) && (task.title === title)) {
				tasks.value.push(task);
			}
		}
		return null;
	}

	public getBucketTasksByTitle(planId: string, bucketId: string, title: string): Tasks {
		const tasks = new Tasks();
		for (const task of this.value) {
			if ((task.planId === planId) &&
				(task.bucketId === bucketId) &&
				(task.title === title)
			) {
				tasks.value.push(task);
			}
		}
		return tasks;
	}

	public getBucketTaskByTitle(planId: string, bucketId: string, title: string): Task | null {
		for (const task of this.value) {
			if ((task.planId === planId) &&
				(task.bucketId === bucketId) &&
				(task.title === title)
			) {
				return task;
			}
		}
		return null;
	}
}

export interface ITasks {
	value?: ITask[];
}
